export default __webpack_public_path__ + "static/media/ic_lock_login.3cb3bc16.svg";